<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    :disabled="dialogVisible"
  >
    <div :class="$style.container">
      <!-- <div :class="$style.banner">
        <img :src="activeInfo.backgroundImage" />
      </div> -->

      <div :class="$style.gameDetail">
        <div :class="$style.gameDetailBox">
          <img :src="activeInfo.logo" alt="" :class="$style.icon" />
          <div :class="$style.info">
            <p :class="$style.name">{{ activeInfo.appName }}</p>
            <p :class="$style.tags">
              <span
                v-for="item in activeInfo.tags"
                :key="item.id"
                :style="{ color: item.labelInfo || '#F39200' }"
                >{{ item.labelName }}</span
              >
            </p>
          </div>
          <button :class="$style.download" @click="onHandleGame(false)">
            查看/下载
          </button>
        </div>
        <div :class="$style.content">
          <div :class="$style.time">
            <CountDown :time="countdownTime" @finish="onRefresh">
              <template #default="timeData">
                礼包刷新倒计时:
                <span>{{ timeData.days }}天</span>
                <span>{{ timeData.hours }}时</span>
                <span>{{ timeData.minutes }}分</span>
                <span>{{ timeData.seconds }}秒</span>
              </template>
            </CountDown>
          </div>
          <div :class="$style.switch">
            <p style="margin-right: 4px; margin-top: 2px">
              {{ tipSwitch ? "已" : "" }}开启提醒
            </p>
            <van-switch
              :value="tipSwitch"
              size="17px"
              active-color="#ffb017"
              @change="onClickSwitch"
            />
          </div>
        </div>
      </div>

      <div :class="$style.skipBtn" @click="onShowRule">活动规则</div>
      <div :class="$style.skipBtn" @click="onShowRecord" style="top: 31%;">领取记录</div>
      <div :class="$style.punchBox">
        <div :class="$style.punch">
          <!-- 礼包内容 -->
          <div :class="$style.giftWrapper">
            <GiftComponent title="周一礼包" :type="1" icon="gift1" :data-source="activeInfo.monGifts" @click-btn="onClickGiftBtn" @click-gift-detail="onToast"/>
            <GiftComponent title="周三礼包" :type="3" icon="gift2" :data-source="activeInfo.wedGifts" @click-btn="onClickGiftBtn" @click-gift-detail="onToast"/>
            <GiftComponent title="周五礼包" :type="5" icon="gift3" :data-source="activeInfo.friGifts" @click-btn="onClickGiftBtn" @click-gift-detail="onToast"/>
            <GiftComponent title="周日礼包" :type="7" icon="gift4" :data-source="activeInfo.sunGifts" @click-btn="onClickGiftBtn" @click-gift-detail="onToast"/>
          </div>
          <div
            :class="$style.punchBtn"
            :style="`filter: ${signStatus !== 0 ? 'grayscale(1)' : 'none'}`"
          > 
            <div v-if="activeInfo.bubble " :class="$style.punchPop">{{ activeInfo.bubble }}</div>
            <p v-if="signStatus == 0" @click="punchIn">点我打卡</p>
            <p v-if="signStatus == 1">今日已打卡</p>
            <p v-if="signStatus == 3" @click="unSatisfiedHint(2)">
              不满足活动条件
            </p>
            <p v-if="signStatus == 4" @click="unSatisfiedHint(4)">
              不满足活动条件
            </p>
          </div>
        </div>
      </div>
    </div>
    <ActivityDialog 
      :title="dialogTitle"
      :visible="dialogVisible"
      :cancel-text="cancelText"
      :sure-text="sureText"
      :hide-cancel="hideCancel"
      :hide-sure="dialogType === 1"
      @click-cancel="dialogVisible = false"
      @click-sure="onClickDialogSure"
    >
      <template v-slot:main>
        <div v-if="dialogType === 0">
          <p>请点击<span>[领取]</span>按钮，领取您</p>
          <p>的今日打卡奖励!</p>
          <p>每<span>周一、周三、周五、周日</span></p>
          <p>来活动页面打卡可领礼包</p>
        </div>
        <div v-if="dialogType === 1">
          <p>恭喜获得<span>[{{ giftName }}]</span>!</p>
          <p>复制下方兑换码到游戏中兑换。</p>
          <p><span>礼包码：{{ cdk }}</span></p>
        </div>
        <div v-if="dialogType === 2">
          <p>当前账号在<span>[{{ activeInfo.appName }}]</span>中</p>
          <p>没有游戏记录，</p>
          <p>进入游戏后可参与活动。</p>
        </div>
        <div v-if="dialogType === 3">
          <p>兑换码生成错误</p>
          <p>请联系客服领取备用码</p>
        </div>
        <div v-if="dialogType === 4">
          <p>当前账号不满足条件，请进入</p>
          <p>游戏且等级达{{ activeInfo.roleLimit }}级后参与活动</p>
        </div>
      </template>
      <template v-slot:sureBtn>
        <button v-if="dialogType === 1" 
          :class="`${$style.sureBtn} copy-btn`"  :data-clipboard-text="cdk">
          {{ sureText }}
        </button>
      </template>
    </ActivityDialog>
  </PullRefresh>
</template>
<script>
import {
  getBtWeekSignInDetailApi,
  setBtWeekSignInApi,
  getBtWeekSignInGiftApi,
  sendPoint,
} from "@/apis/btBoxActivity";
import { CDN_URL_1, CDN_URL } from "@/config";
import { getCookie, pageLoseTips } from "@/libs/utils";
import { inithandler } from "@/bridge/jsBridge";
import {
  setPageTitle,
  toLogin,
  getUserInfo,
  openNotification,
  isOpenNotification,
  dataLoadFinished,
  jumpToNative
} from "@/bridge/AppJsBridge";

import { PullRefresh, CountDown, Toast } from "vant";
import GiftComponent from "./component/GiftContent.vue";
import ActivityDialog from "@/components/btBox/ActivityDialog";
import moment from "moment";
import Clipboard from "clipboard";

export default {
  components: {
    PullRefresh,
    CountDown,
    GiftComponent,
    ActivityDialog
  },
  data() {
    return {
      pageTitle: '周打卡活动',
      closeImg: `${CDN_URL}/packet/close.png`,
      CDN_URL_1,
      dialogVisible: false,
      dialogType: 0, // 0. 打卡 1. 礼包领取成功 2.不满足活动条件 3.礼包码生成错误
      dialogTitle: "打卡成功",
      cancelText: "开启提醒",
      sureText: "我知道了",
      hideCancel: false,
      isLoading: false,
      cookie: null,
      tipSwitch: false,
      signStatus: 0, // 当天签到状态
      activeInfo: {}, // 活动数据
      gameList: [],
      curId: 0,
      giftName: "", // 当前领取礼包名称
      giftId: "", // 当前领取礼包id
      giftType: null,
      cdk:'',
      isPlay: null,
      requireLevel: '', // 等级要求
    };
  },
  created() {
    // 页面初始化
    // inithandler();
    this.getBaseInfo();
  },
  mounted() {
    this.copyInit();
  },
  computed: {
    countdownTime: function () {
      let time = 7 * 24 * 60 * 60 * 1000;
      if (this.activeInfo.nowTime && this.activeInfo.nextTime) {
        time =
          moment(this.activeInfo.nextTime).valueOf() -
          moment(this.activeInfo.nowTime).valueOf();
      }
      return time;
    },
  },
  activated() {
    // this.getBaseInfo();
    this.dialogVisible = false;
  },

  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.getBaseInfo();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    
    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      sendPoint({
        ...this.cookie,
        ...data,
        appName: this.activeInfo.appName,
        appkey: this.activeInfo.gameId,
      }).catch((err) => console.log(err));
    },

    onToast(data){
      if (data) {
        Toast({
          message:data[0].giftDetail,
          // position: 'top',
          duration: 5000
        })
      }
    },

    // 跳转系统权限
    onClickSwitch(value) {
      if (!this.activeInfo.appName) {
        return;
      }
      openNotification();
      this.eventTrack({
        event: "week_sign_open_tip",
        event_field: JSON.stringify({
          activity_name: this.pageTitle,
          tip_status: Number(this.tipSwitch),
          is_play: this.isPlay
        }),
      });
    },

    // 页面初始化
    async getBaseInfo() {
      const { history } = this.$router;
      const { query } = history.current;
      if (query.placeId) {
        this.curId = query.placeId;
        this.isPlay = query.isPlay;
      }
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) && pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      this.getAppToken();
    },
    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getPageMainData(this.curId);
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            localStorage.setItem("token", Info.token);
          }
          this.getPageMainData(this.curId);
        });
      }
    },

    getPageMainData(placeId) {
      getBtWeekSignInDetailApi({ placeId })
        .then((res) => {
          dataLoadFinished();
          this.activeInfo = res.data;
          this.pageTitle = res.data.activityName;
          this.signStatus = res.data.signStatus;
          setPageTitle(res.data.activityName);
          this.getTipSwitchStatus();
        }).catch((error) => {
          if (error && error.code === 401) {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        });
    },

    copyInit() {
      this.copy = new Clipboard(".copy-btn");
      this.copy.on("success", (e) => {
        this.dialogVisible = false;
        this.$toast("兑换码复制成功，请进入游戏兑换");
        this.eventTrack({
          event: "week_sign_pop_copy_code",
          event_field: JSON.stringify({ 
            activity_name: this.pageTitle,
            gift_id: this.giftId,
            gift_name: this.giftName,
            gift_type: this.giftType,
            is_play: this.isPlay
          }),
        });
      });
    },

    onShowRule() {
      this.$router.push({
        name: `box.btActRule`,
        params: {
          type: 5,
        },
      });
      this.eventTrack({
        event: "week_sign_rule",
        event_field: JSON.stringify({ activity_name: this.pageTitle,is_play: this.isPlay }),
      });
    },

    onShowRecord(){
      this.$router.push({
        name: `box.btWeekSignInAct.record`,
        query: {
          gameId: this.activeInfo.gameId,
          placeId: this.curId
        },
      });
      this.eventTrack({
        event: "week_sign_gift_get_log",
        event_field: JSON.stringify({ activity_name: this.pageTitle,is_play: this.isPlay }),
      });
    },
    /**
     * 获取当前页面通知权限开关状态
     */
    getTipSwitchStatus() {
      isOpenNotification((status) => {
        console.log("🚀 ~ file: isOpenNotification方法返回值", status);
        // 首次进入此方法无效，后续修改开关返回当前页面获取状态更新
        this.tipSwitch = status == "1" ? true : false;
        this.eventTrack({
            event: "week_sign_page",
            event_field: JSON.stringify({ 
              activity_name: this.pageTitle,
              tip_status: Number(status),
              is_play: this.isPlay
            }),
          });
      });
    },

    /**
     * 统一处理不同类型弹窗状态
     * @param {*} type 弹窗类型
     */
    setDialogStatus(type){
      let title='',sureText='',cancelText='',hideCancel = false;
      this.dialogVisible = true;
      this.dialogType = type;
      if (type === 0) {
        title = "打卡成功";
        sureText = "我知道了";
        hideCancel = true;
      }
      if (type === 1) {
        title = "领取成功";
        cancelText = "取消";
        sureText = "复制礼包码";
      }
      if (type === 2) {
        title = "不满足活动条件";
        cancelText = "取消";
        sureText = "下载/查看游戏";
      }
      if (type === 3) {
        title = "提示";
        cancelText = "取消";
        sureText = "联系客服";
      }
      if (type === 4) {
        title = "不满足活动条件";
        cancelText = "取消";
        sureText = "下载/查看游戏";
      }
      this.dialogTitle = title;
      this.sureText = sureText;
      this.cancelText = cancelText;
      this.hideCancel = hideCancel
    },

    // 点击打卡
    async punchIn() {
      if (!this.curId) {
        return;
      }
      this.eventTrack({
        event: "week_sign_sign_icon",
        event_field: JSON.stringify({
          activity_name: this.pageTitle,
          icon_type: 1,
          is_play: this.isPlay
        }),
      });
      setBtWeekSignInApi({ placeId: this.curId })
        .then((res) => {
          const { data } = res;
          // 刷新页面
          this.getPageMainData(this.curId);
          if (!data.signState) {
            this.$toast("打卡失败，请重试~");
            return;
          }
          this.setDialogStatus(0);
          this.eventTrack({
            event: "week_sign_sign_result_pop",
            event_field: JSON.stringify({
              activity_name: this.pageTitle,
              sign_result: 1,
              is_play: this.isPlay
            }),
          });
        })
        .catch((error) => {
          console.log("🚀 ~ file: ~ punchIn ~ error", error)
          // 刷新页面
          this.getPageMainData(this.curId);
        });
    },

    // 不满足活动条件按钮点击
    unSatisfiedHint(type = 2) {
      this.setDialogStatus(type);
      this.eventTrack({
        event: "week_sign_sign_icon",
        event_field: JSON.stringify({
          activity_name: this.pageTitle,
          icon_type: type,
          is_play: this.isPlay
        }),
      });
      this.eventTrack({
        event: "week_sign_sign_result_pop",
        event_field: JSON.stringify({
          activity_name: this.pageTitle,
          sign_result: type,
          is_play: this.isPlay
        }),
      });
    },

    async onClickGiftBtn(giftInfo, type) {
      const { giftState, giftId, giftName,cdk } = giftInfo[0];
      const successAction = (hasEvent=true) => {
        this.setDialogStatus(1);
        this.giftName = giftName;
        this.giftId = giftId;
        this.giftType = type;
        if (cdk) {
          this.cdk = cdk;
        }
        if (hasEvent) {
          this.eventTrack({
            event: "week_sign_gifts_get_pop",
            event_field: JSON.stringify({
              activity_name: this.pageTitle,
              gift_id: giftId,
              gift_name: giftName,
              get_result: 1,
              gift_type:type,
              is_play: this.isPlay
            }),
          });
        }
      };
      const errorAction = (result) => {
        this.setDialogStatus(3);
        this.eventTrack({
          event: "week_sign_gifts_get_pop",
          event_field: JSON.stringify({
            activity_name: this.pageTitle,
            gift_id: giftId,
            gift_name: giftName,
            get_result: result,
            gift_type:type,
            is_play: this.isPlay
          }),
        });
      };
      if (giftState == 0) {
        this.eventTrack({
          event: "week_sign_gift_get",
          event_field: JSON.stringify({
            activity_name: this.pageTitle,
            gift_id: giftId,
            gift_name: giftName,
            gift_type:type,
            is_play: this.isPlay
          }),
        });
        getBtWeekSignInGiftApi({ placeId: this.curId, giftId })
          .then((res) => {
            const { data } = res;
            if (data.cdk) {
              this.cdk = data.cdk;
              successAction();
            } else {
              errorAction(1);
            }
            // 领取后刷新页面
            this.getPageMainData(this.curId);
          }).catch((error) => {
            errorAction(0);
            // 领取后刷新页面
            this.getPageMainData(this.curId);
          });
        // 可领取
        return;
      }
      if (giftState == 9) {
        successAction(false);
        // 已领取
        return;
      }
    },

    // 弹窗确定按钮
    onClickDialogSure() {
      this.dialogVisible = false;
      if (this.dialogType === 1) {
        // this.onHandleGame(true);
      }
      if ([2, 4].includes(this.dialogType)) {
        this.onHandleGame(true);
      }
      if (this.dialogType === 3) {
        this.onRelationServer();
      }
    },

    // 游戏详情
    onHandleGame(isPop = false) {
      if (!this.activeInfo.gameId) {
        return;
      }
      let event = "";
      if (isPop) {
        event = "week_sign_pop_downlod_game";
      } else {
        event = "week_sign_game_scan";
      }
      this.eventTrack({
        event: event,
        event_field: JSON.stringify({ activity_name: this.pageTitle,is_play: this.isPlay }),
      });
      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams: this.activeInfo.gameId,
        fromPageType: 18,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },

    // 联系客服
    onRelationServer() {
      this.eventTrack({
        event: 'week_sign_pop_linkme',
        event_field: JSON.stringify({ 
          activity_name: this.pageTitle, 
          gift_id: this.giftId,
          gift_name: this.giftName,
          gift_type: this.giftType,
          is_play: this.isPlay
        }),
      });
      this.$router.push({
        name: `box.customerService`,
      });
    },
  },
};
</script>
<style lang="scss" module>
.sureBtn {
  background: #ffb017;
  color: #ffffff;
}
.container {
  width: 100vw;
  min-height: 100vh;
  overflow-y: auto;
  padding-top: 10px;
  background: url("#{$cdn-url-2}/box_btWeekSignIn/btWeekSignInBg.jpg") no-repeat;
  background-size: 100% 100%;
  .banner {
    display: block;
    width: 93%;
    margin: auto;
    padding: 4px;
    border-radius: 4px;
    background-color: #ffffff;
    > img {
      display: block;
      width: 100%;
      max-height: 196px;
      margin: auto;
    }
  }
  .gameDetail {
    display: block;
    width: 93%;
    height: 132px;
    margin: auto;
    padding: 4px;
    border-radius: 4px;
    background-color: #ffffff;
    // margin-top: 10px;
    box-shadow: -3.82px 0px 6.25px 3.82px rgba(173, 173, 173, 0.25);
    .gameDetailBox {
      // background: linear-gradient(180deg, #fde6d6 0%, #ffd6b5 100%);
      width: 100%;
      height: 92px;
      padding: 10px;
      display: flex;
      align-items: center;
      position: relative;
      .icon {
        width: 66.7px;
        height: 66.7px;
      }
      .info {
        margin-left: 4px;
        .name {
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          color: #333333;
          margin-bottom: 9px;
        }
        .categoryNames {
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          margin-bottom: 8px;
        }
        .tags {
          > span {
            background-color: #fff5d1;
            padding: 1px 2px;
            font-size: 12px;
            margin-right: 2px;
          }
        }
      }
      .download {
        position: absolute;
        right: 14px;
        border: none;
        outline: none;
        background: none;
        // width: 59px;
        height: 24px;
        border: 1px solid #ffb017;
        border-radius: 12.85px;
        color: #ffb017;
        &:active {
          opacity: 0.8;
        }
      }
    }
  }

  .content {
    margin: 4px auto 16px;
    width: calc(100% - 6px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .switch {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
      display: flex;
      align-items: center;
    }
    .time {
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #333333;
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        font-weight: 400;
        color: #fc5f5e;
        line-height: 14px;
      }
    }
  }
  .skipBtn{
    width: 64px;
    height: 24px;
    line-height: 24px;
    background: rgba(255,176,23,0.79);
    border: 1px solid;
    border-radius: 11.11px 0px 0px 11.11px;
    box-shadow: 0px 0px 2.78px 0px rgba(174,94,0,0.76); 
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    position: fixed;
    right: 0px;
    top: 24%;
    z-index: 1;
  }
  .punchBox {
    width: 93%;
    margin: 10px auto;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: -3.82px 0px 6.25px 3.82px rgba(173, 173, 173, 0.25);
    .punch {
      min-height: 430px;
      padding: 0 16px 15px;
      position: relative;
      .giftWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
      }
      .punchBtn {
        margin: 15px auto 0;
        width: 100%;
        height: 56px;
        background: #ffb017;
        border-radius: 29.51px;
        position: relative;
        > p {
          color: #ffffff;
          font-size: 21px;
          width: 100%;
          line-height: 55px;
          font-weight: 700;
          text-align: center;
          letter-spacing: 1px;
        }

        .punchPop{
          width: 137px;
          height: 31px;
          background: url("#{$cdn-url-2}/box_btWeekSignIn/btPop.png") no-repeat;
          position: absolute;
          top: -16px;
          right: 0;
          height: 30px;
          background-size: 100% 100%;
          color: #d6d6d6;
          font-size: 12px;
          text-align: center;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
